import { useEffect } from 'react';

/**
 * Side Effect hook for syncing compare and trim query string from URL
 *
 * @param {*} {
 *   trims,
 *   trimKeysString,
 *   isInit,
 *   setActiveTab,
 *   setIsInit,
 *   language,
 *   setSelectedTrim,
 *   setCurrentSlide,
 * }
 */
const useCompareAndTrimQuerystring = ({
  trims,
  trimKeysString,
  isInit,
  setActiveTab,
  setIsInit,
  language,
  setSelectedTrim,
  setCurrentSlide,
}) => {
  // If there's a `compare` querystring param, set active tab to 1.
  // If there's a `trim` querystring param, set the current slide to that
  useEffect(() => {
    if (typeof document !== 'undefined' && isInit) {
      const params = new URL(document.location).searchParams;
      const compareTrimsParam = params.get(language === 'fr' ? 'comparer' : 'compare');
      const selectedTrimParam = params.get('trim');

      if (compareTrimsParam) {
        setActiveTab(1);
        setIsInit(false);
      } else if (selectedTrimParam) {
        setSelectedTrim(selectedTrimParam);
        const selectedTrimIndex = trims?.findIndex(trim => trim.detIdentifier.value === selectedTrimParam);
        if (selectedTrimIndex > 0) {
          setCurrentSlide(selectedTrimIndex);
          setIsInit(false);
        }
      }
    }
  }, [trimKeysString, isInit, setActiveTab, setIsInit, language]);
};

export default useCompareAndTrimQuerystring;
